import axios from 'axios';

const defaultServerError = (response) => {};

const defaultError = (response) => {
  return 'Oops, an error occurred.';
};

const defaultNetworkError = () => {
  return 'Oops, an error occurred.';
};

const interceptorFactory =
  ({
    onServerError,
    onDefaultError,
    onNetworkError,
    statusCodeHandlerMap,
    onSuccess,
  }) =>
  () => {
    return {
      onSuccess,
      onError: (error) => {
        if (!axios.isCancel(error)) {
          const response = error.response;
          if (response) {
            if (response.status >= 500) {
              onServerError(response);
            } else {
              const responseHandler =
                statusCodeHandlerMap[response.status] || onDefaultError;
              responseHandler && responseHandler(response);
            }
          } else {
            onNetworkError(response);
          }
        }

        return Promise.reject(error);
      },
    };
  };

const defaultInterceptor = interceptorFactory({
  onServerError: defaultServerError,
  onDefaultError: defaultError,
  onNetworkError: defaultNetworkError,
});

// const defaultInterceptor = (config = {}) => {
//   config.headers = {};
//   const token = sessionStorage.getItem('token');
//   console.log("Token is:- ",token)
//   if (token) {
//     config.headers['x-access-token'] = token;
//     console.log('Token added to headers:', token);
//   }
//   else{
//     console.log("No token found")
//   }
//   config.headers['Cache-Control'] = 'no-cache';
//   config.headers.Pragma = 'no-cache';
//   config.headers.Expires = '-1';
//   config.headers['Access-Control-Allow-Origin'] = '*';
//   return config;
// };

export const createHttpClient = (
  baseUrl,
  ResponseInterceptor,
  RequestInterceptor
) => {
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    withCredentials: false,
  });
  console.log("Interceptor going to use - ",RequestInterceptor)
  if (RequestInterceptor) {
    axiosInstance.interceptors.request.use(RequestInterceptor);
  }

  let interceptor;
  if (ResponseInterceptor) {
    interceptor = ResponseInterceptor();
    axiosInstance.interceptors.response.use(
      interceptor.onSuccess,
      interceptor.onError
    );
  } else {
    interceptor = defaultInterceptor();
  }
  const { onSuccess, onError } = interceptor;
  axiosInstance.interceptors.response.use(onSuccess, onError);
  return axiosInstance;
};

const requestInterceptor = (config = {}) => {
  config.headers = {};
  const token = sessionStorage.getItem('token');
  console.log("Token is:- ",token)
  if (token) {
    config.headers['x-access-token'] = token;
    console.log('Token added to headers:', token);
  }
  else{
    console.log("No token found")
  }
  config.headers['Cache-Control'] = 'no-cache';
  config.headers.Pragma = 'no-cache';
  config.headers.Expires = '-1';
  config.headers['Access-Control-Allow-Origin'] = '*';
  return config;
};
export { requestInterceptor };